module.exports = __webpack_public_path__ + "images/stickers/clock@2x.5366f89447c3e91f47d7.png";